import { render, staticRenderFns } from "./info.vue?vue&type=template&id=715aca18&scoped=true&"
var script = {}
import style0 from "./info.vue?vue&type=style&index=0&id=715aca18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715aca18",
  null
  
)

export default component.exports